import { ReactNode, useContext } from 'react';

import { AlertColor } from '@mui/material';

import { useChangeDetectorContextState } from '../../../firmware-management/components/FirmwareForm/hooks/change-detector-context-state/use-change-detector-context-state.hook';
import { SnackBarContext } from '../../components/snack-bar-context/SnackBarContext';
import { SnackBarContextModel } from '../../components/snack-bar-context/models/snack-bar-context.model';

export const useSnackbarContextState = (): ((
  severity: AlertColor,
  message: string,
  icon: boolean | ReactNode,
  isOpen?: boolean
) => void) => {
  const snackBarContext = useContext(SnackBarContext) as SnackBarContextModel;
  const changeDetectorConfig = useChangeDetectorContextState();
  return (
    severity: AlertColor,
    message: string,
    icon: boolean | ReactNode,
    isOpen?: boolean
  ): void => {
    const configureLogic = () => {
      snackBarContext.changeSeverity(severity);
      snackBarContext.changeMessage(message);
      snackBarContext.changeIcon(icon);
      if (severity === 'success') {
        changeDetectorConfig(false);
      }
      if (isOpen) {
        snackBarContext.isOpen(isOpen);
      }
    };
    return configureLogic();
  };
};
